<template>
  <div class="app-customer-contract-dismissal-form">
    <div class="card-wrapper">
      <div class="card">
        <slot name="txtBefore"></slot>
        <form>
          <b-form-group class="select-reason" :class="vflowGetFeedbackClasses('selectReason')">
            <b-form-radio-group v-if="allReasons" name="reasonSelection" class="rows custom-radio" v-model="selectReason" @change="$v.selectReason.$touch()">
              <label class="radio-label mandatory"><slot name="lblReason">Der Kündigungsgrund:</slot></label>
              <b-form-radio
                :key= reason.key
                :value=reason.key
                class="reasonSelection"
                plain
                :id="'reasonSelection_' + reason.key"
                v-for="(reason) in allReasons"
                ><div v-html="reason.value"></div>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-form-group  class="comment">
            <label for="comment"><slot name="lblComment">Hast du noch weitere Anmerkungen? Ich bin ganz Ohr!</slot></label>
            <b-form-textarea
              id="comment"
              v-model="comment"
              rows="5"
              :placeholder="this.$slots.txtPlaceholderTextarea && this.$slots.txtPlaceholderTextarea[0] ? this.$slots.txtPlaceholderTextarea[0].text : 'Hier Texten'"
            ></b-form-textarea>
          </b-form-group>
        </form>
      </div>
    </div>
    <slot name="txtAfterCard"></slot>
    <Stepper
      @prev="prev()"
      @next="send()"
      :show-prev="true"
      :disabled-next="loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import Stepper from '@/components/generic/Stepper.vue'
import validationFlow from '@/mixins/validators/validationFlow'
import gql from 'graphql-tag'
import transaction from '@/mixins/transaction'
import { splitError } from '@/helper/splitError'
import beErrors from '@/mixins/beErrors'
import { wrapQuery } from '@/helper/wrapGQLQuery'

export default {
  name: 'SelfServiceContractDismissalForm',
  data () {
    return {
      viewModal: false,
      selectReason: '',
      comment: '',
      contractDismissal: null,
      loading: false
    }
  },
  mounted () {
    this.startLoader()
    this.stopLoader()
  },
  methods: {
    prev () {
      window.location.href = this.selfserviceContractId
    },
    send () {
      this.loading = true
      this.$v.$touch()
      this.vflowForceFeedback()
      if (!this.$v.$invalid) {
        this.sendContractDismissal()
      } else {
        this.loading_ = false
        this.loading = false
        // ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then(function (result) {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    errorMessage (error) {
      const firstMessage = splitError(error)?.[0]
      if ((firstMessage && firstMessage.extensions?.category === 'graphql') || firstMessage === undefined) {
        // technical error message, do not use for customer
        return this.fallbackErrorMessage()
      }
      return firstMessage.message
    },
    fallbackErrorMessage: function () {
      return this.getSlotText('txtTechnicalError', 'Es ist ein technischer Fehler aufgetreten.')
    },
    sendContractDismissal () {
      const me = this
      const graphQlClient = me.$apolloProvider.defaultClient

      this.startLoader()

      graphQlClient
        .mutate({
          mutation: gql`
        mutation changeContractDismissal($changeContractDismissal: ChangeContractDismissalInput!) {
          changeContractDismissal(changeContractDismissal: $changeContractDismissal) {
            success
          }
        }
      `,
          variables: {
            changeContractDismissal: {
              comment: this.comment,
              dismissalDate: this.possibleDismissalDate,
              dismissalReason: this.selectReason
            }
          }
        })
        .then(() => {
          window.location.href = this.selfserviceContractId
        })
        .catch((error) => {
          me.clearToasts()
          me.errorToast(this.errorMessage(error))
        })
        .finally(() => {
          this.stopLoader()
        })
    }
  },
  components: {
    Stepper
  },
  computed: {
    allReasons: function () {
      return this.possibleDismissalReasons?.map(child => {
        return {
          key: child.reasonKey,
          value: child.description
        }
      }) || null
    },
    possibleDismissalDate () {
      return this.contractDismissal?.possibleDismissal?.nextPossibleDismissalDate || null
    },
    possibleDismissalReasons () {
      const reasons = this.contractDismissal?.possibleDismissal?.possibleDismissalReasons || []
      return reasons.reverse()
    }
  },
  mixins: [
    validationMixin,
    validationFlow,
    transaction('changeContractDismissal'),
    beErrors

  ],
  validations () {
    return {
      selectReason: {
        required
      }
    }
  },
  props: {
    selfserviceContractId: {
      type: String,
      default: '#'
    }
  },
  apollo: {
    currentCustomerContract: function () {
      return wrapQuery(
        gql`query changeContractDismissal {
            contractDismissal {
              contractDismissal
              possibleDismissal {
                nextPossibleDismissalDate
                possibleDismissalReasons {
                  description
                  reasonKey
                }
              }
              pendingDismissal {
                dismissalDate
              }
            }
          }`, this, 'contractDismissal',
        {}, () => {}, {},
        (error) => {
          this.error = error
        }
      )
    }
  }
}

</script>
